import React from 'react';

const BuildSelectOptions = options => {
  return options.map(option => {
    const value = option.hasOwnProperty('id') ? option.id : option.value;
    return <option key={value} value={value}>{option.label}</option>;
  });
};

const QuestionRowSelector = (props) => {
  const {
    availableRows = [],
    onChange,
    onRemove,
    disableRemove = false,
    renderTrashBtn,
    renderGoalLabel
  } = props;

  const goalOptions = BuildSelectOptions(availableRows);

  const typeChanged = (event) => {
    onChange(event.target.value);
  };

  const cssBem = 'questionBuilder';

  const removeButton = !disableRemove ?
    <button className="btn btn-link remove" onClick={onRemove}>{ renderTrashBtn }</button> : null;

  return <div className={`${cssBem}__row row-selector`}>
    <div className={`${cssBem}__question`}>
      <label className={`${cssBem}__label`}>{renderGoalLabel}</label>
      <div className={`${cssBem}__cell`}>
        <select className={`${cssBem}__selector`} onChange={typeChanged}>
          <option value="">Please select</option>
          {goalOptions}
        </select>
      </div>
    </div>
    {removeButton}
  </div>;
};

export default QuestionRowSelector;
